import styled from 'styled-components';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import {
    BORDER_COLOR,
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    LARGE_TEXT_PX,
    PINK_HIGHLIGHT_COLOR,
    PRIMARY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    SMALL_TEXT_PX,
    TITLE_FONT_COLOR,
    X_SMALL_TEXT_PX,
    X_LARGE_TEXT_PX,
    BASE_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

export const BatchPopupTitle = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 767px) {
        align-items: flex-start;
        flex-direction: column;
        gap: 4px;
    }
`;

export const BatchPopupTitleStatus = styled.span`
    align-items: center;
    display: inline-flex;
    gap: 4px;
`;

export const BatchNumber = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${X_LARGE_TEXT_PX};
    line-height: 36px;
    font-weight: 600;   
`;

export const BatchPopupTitleLabel = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
`;

export const BatchPopupTitleStatusValue = styled.span`
    color: ${PINK_HIGHLIGHT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
`;
export const SummaryDetails = styled.div`
    display: block;
    padding:16px 20px 0 20px;
    @media (max-width: 767px) {
        
        padding: 12px 16px 0 16px;
    }
`;

export const BatchPopupContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    gap: 20px;
    width: 100%;
`;

export const BatchPopupShell = styled.div`
    background: whitesmoke;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
`;

export const BatchPopupScrollContainer = styled.div`
    -webkit-overflow-scrolling: touch;
    background: whitesmoke;
    flex: 1 1 auto;
    min-height: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    ${scrollBarStyle}

    @media (max-width: 767px) {
        box-sizing: border-box;
        padding-bottom: 180px;
    }
`;

export const BatchPopupHeader = styled.div`
    //margin-bottom: 10px;
`;

export const SummaryGrid = styled.div`
    display: grid;
    flex-shrink: 0;
    grid-template-columns: repeat(1, minmax(0, 1fr));    
    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const SummaryItem = styled.div`
    display: block;
`;

export const SummaryLabel = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX};
`;

export const SummaryValue = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
    
`;

export const TabControlSection = styled.div`
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;

    .p-tabview {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        min-height: 0;
        min-width: 0;
        width: 100%;
    }

    .p-tabview-nav {
        display: flex;
        flex-shrink: 0;
        margin: 0 20px;

        @media (max-width: 767px) {
            margin: 0 16px;
            width: calc(100% - 32px);
        }
    }

    .p-tabview-nav li {
        @media (max-width: 767px) {
            flex: 1 1 0;
        }
    }

    .p-tabview-nav li .p-tabview-nav-link {
        @media (max-width: 767px) {
            padding: 1rem 0;
        }
    }

    .p-tabview-nav li.p-tabview-selected .p-tabview-title{
        color: ${TITLE_FONT_COLOR};
    }

    .p-tabview-panels {
        display: flex;
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
        margin: 10px 0
    }

    .p-tabview-panel {
        display: flex;
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
    }
`;

export const LoadingSpinnerContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 200px;
    width: 100%;
`;

export const TabPanelContent = styled.div`
    background: ${({ $background }) => $background || 'none'};
    border-radius: ${({ $borderRadius }) => $borderRadius || '0'};
    flex: 1 1 auto;
    min-height: 0;
    padding: ${({ $padding }) => $padding || '0'};
    box-sizing: ${({ $setContent }) => ($setContent ? 'border-box' : undefined)};
    min-width: ${({ $setContent }) => ($setContent ? '0' : undefined)};
    width: ${({ $setContent }) => ($setContent ? 'auto' : '100%')};
    overflow-y: auto;
    overflow-x: hidden;
    margin: ${({ $setContent }) => ($setContent ? '5px 20px' : '0')};
    box-shadow: ${({ $setContent }) => ($setContent ? '0px 0px 6px #00000029' : 'none')};
    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    @media screen and (max-width: 1024px) {
        &::-webkit-scrollbar {
            display: block;
        }
    }
    @media screen and (max-width: 767px) {
        padding: 0;
        margin: ${({ $setContent }) => ($setContent ? '5px 0' : '0')};
    }
`;

export const AdditionalDetailsCards = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px 20px;
    @media (max-width: 767px) {
        padding: 0;
    }

`;

export const AdditionalDetailsCardChevron = styled.span`
    align-items: center;
    display: inline-flex;
    height: 16px;
    justify-content: center;
    transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s ease;
    width: 16px;
`;

export const PlaceholderText = styled.div`
    color: ${SECONDARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
`;

export const KeyValueList = styled.div`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(${({ $columns }) => ($columns && $columns > 1 ? $columns : 1)}, minmax(0, 1fr));

    @media (max-width: 1024px) {
        grid-template-columns: repeat(${({ $columns }) => ($columns && $columns > 2 ? 2 : 1)}, minmax(0, 1fr));
    }

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const KeyValueRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const RowLabel = styled.span`
    color: ${SECONDARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${X_SMALL_TEXT_PX};
`;

export const RowValue = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    overflow-wrap: anywhere;
`;

export const AdditionalDetailsRowLabel = styled(RowLabel)`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${SMALL_TEXT_PX};
    color: ${PRIMARY_FONT_COLOR};
`;

export const AdditionalDetailsRowValue = styled(RowValue)`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
    color: ${SECONDARY_FONT_COLOR};
`;

export const BulletList = styled.ul`
    color: ${PRIMARY_FONT_COLOR};
    display: flex;
    flex-direction: column;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    gap: 8px;
    margin: 0;
    padding-left: 18px;
`;

export const ActionsRow = styled.div`
    background: #ffffff;
    box-shadow: 0px -3px 6px #00000014;
    display: flex;
    flex-shrink: 0;
    gap: 12px;
    justify-content: flex-end;
    padding: 12px 16px;

    @media (max-width: 767px) {
        flex-direction: column-reverse;
        justify-content: center;
    }
`;